export type TenantLabel = string;

export const TenantLabel = {
	ONMSChina: '62d11549-4655-4f82-9472-c5c46ff13f3b',
	EMCloudAD: 'd1ee1acd-bc7a-4bc4-a787-938c49a83906',
	ExxonMobilTest: '62d11549-4655-4f82-9472-c5c46ff13f3b',
};